module.exports = __webpack_public_path__ + "static/media/U1-T2-2-4c.c3ef59ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-4c.svg
// module id = 558
// module chunks = 0